import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFormatPrice } from 'hooks/i18n';
import Tile from '@/molecules/Tile';
import { PayoutJsonldPayoutRead } from '@/api/generated';

type CartDetailType = {
  title: string;
  className?: string;
  data: PayoutJsonldPayoutRead | undefined;
};

type GroupItems = Array<Array<{ label: string; value: string | null | undefined; lineClassName?: string }>>;

const HistoryCartDetail = ({ title, className, data }: CartDetailType) => {
  const { t } = useTranslation();
  const { formatUserCurrency } = useFormatPrice();
  const groupItems: GroupItems = data
    ? [
        [
          ...(data.fees
            ? [
                {
                  label: t('wallet.payoutModal.detaill.walletFee'),
                  value: formatUserCurrency(data.fees),
                },
              ]
            : []),
          {
            label: t('wallet.payoutModal.detaill.serviceFee'),
            value: t('free'),
          },
        ],
        [
          {
            label: t('total'),
            value: formatUserCurrency(data.total!),
            lineClassName: 'sm-bold text-faction-ordis text-lg text-neutral-800',
          },
        ],
      ]
    : [];

  return (
    <Tile className={clx(className)} title={title}>
      <div className="gap-2 flex flex-col">
        <div className="h-px" />
        {groupItems.map((items, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className="gap-2 flex flex-col text-neutral-500">
            {items.map((item) => (
              <p
                key={item.label}
                className={clx('flex justify-between sm-regular text-neutral-500', item.lineClassName)}
              >
                <span className="mr-auto">{item.label}</span>
                <span className="text-neutral-800">{item.value}</span>
              </p>
            ))}
            {!!groupItems[i + 1] && <div className="bg-sand-200 h-px" />}
          </div>
        ))}
      </div>
    </Tile>
  );
};

export default HistoryCartDetail;
